export default (data, options) => {
    // eslint-disable-next-line no-console
    console.log('form submit', data, options);

    return new Promise((resolve) => {
        setTimeout(() => resolve(options.successMessage), 2000);
    });
};
